import React from 'react';
import { Menu, Bell, User, Settings } from 'lucide-react';

const MobileHeader = ({ 
  sidebarLogo, 
  onMenuClick, 
  userdata, 
  activeTab,
  onNotificationClick,
  onProfileClick,
  rightSlot
}) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-30 bg-white border-b border-gray-200 shadow-sm lg:hidden">
      <div className="grid grid-cols-[auto_1fr_auto] items-center gap-2 px-4 py-3">
        {/* Logo and Menu */}
        <div className="flex items-center space-x-2">
          {onMenuClick && (
            <button
              onClick={onMenuClick}
              className="p-2.5 rounded-lg hover:bg-gray-100 transition-colors active:scale-95"
            >
              <Menu size={24} className="text-gray-700" />
            </button>
          )}
          <img 
            src={sidebarLogo} 
            alt="Logo" 
            className="h-8 w-auto max-w-[120px] object-contain"
          />
        </div>

        {/* Page Title */}
        <div className="min-w-0 text-center">
          <h1 className="text-lg font-semibold text-gray-900 truncate">
            {activeTab}
          </h1>
        </div>

        <div className="flex justify-end">{rightSlot}</div>
      </div>

      {/* Progress indicator for current page */}
      <div className="h-1 bg-gray-100">
        <div className="h-full bg-blue-600 transition-all duration-300" style={{ width: '100%' }}></div>
      </div>
    </div>
  );
};

export default MobileHeader;
